<script>
(function(){
  var t = document.getElementsByTagName('script')[0];
  var s = document.createElement('script'); s.async = true;
  s.src = 'https://widget.nfusionsolutions.com/widget/script/ticker/1/b750eadd-82dd-4241-92c7-50a4a862c51d/7136a1c8-ecab-40ac-ad21-50dd96662c28';
  t.parentNode.insertBefore(s, t);
})();

  (function(){
  var t = document.getElementsByTagName('script')[0];
  var s = document.createElement('script'); s.async = true;
  s.src = 'https://widget.nfusionsolutions.com/widget/script/chart/1/b750eadd-82dd-4241-92c7-50a4a862c51d/fb2f0c84-798a-4aa9-8bdc-48f713a607ed';
  t.parentNode.insertBefore(s, t);
})();
export default {
  name: "HeaderChart",
  data() {
    return {
      displayChart: false,
      chartText: 'View Charts'
    }
  },
  methods: {
    toggleDisplayChart() {
      this.displayChart = !this.displayChart
      this.chartText = this.chartText == 'View Charts' ? 'Hide Charts' : 'View Charts'
      console.log(this.displayChart)
    }
  }
}
</script>

<template>
  <div class="charts-bar">
    <div class="charts-bar-wrapper">
      <div class="charts">
        <div id='7136a1c8-ecab-40ac-ad21-50dd96662c28' style='width:100%;height:100%;'></div>
      </div>
      <div class="view-charts">
        <span class="charts-link text-white" style="cursor: pointer" @click="toggleDisplayChart()">{{ chartText }}</span>
      </div>
    </div>
    <div class="charts-table-wrapper" :class="{ 'd-none': !displayChart }" style="top: 39px">
      <div class="charts-table">
        <button type="button" class="close-charts" @click="toggleDisplayChart()"></button>
        <div id='fb2f0c84-798a-4aa9-8bdc-48f713a607ed' style='width:100%;height:100%;'></div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
